import { render, staticRenderFns } from "./sns_icon_list.vue?vue&type=template&id=11d57495&"
import script from "./sns_icon_list.vue?vue&type=script&lang=js&"
export * from "./sns_icon_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports